/*
 *   File : notification-modal.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */
import React from "react";
import { PrimaryButton } from "../Cta";

export default function NotificationModal({ close, data }) {
  return (
    <div className="position-fixed top-0 end-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-end p-0">
      <div className="notification-modal-wrapper d-flex flex-column row-gap-3">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className=" text-center e-font-weight-600 e-font-16 line-height-32px e-primary-font-poppins m-0">
            View notification
          </h5>
          <PrimaryButton
            icon="close-button"
            ClassName="bg-transparent p-1"
            onPress={close}
            size="14px"
          />
        </div>
        <div className="e-bg-ghost-white d-flex flex-column e-border-radius-16 p-3 e-border-1px-pale-lavender row-gap-3">
          <div>
            <h5 className=" e-font-14 e-font-weight-400">Sent on</h5>
            <p className="e-font-14 e-font-weight-500">{data.created}</p>
          </div>
          <div>
            <h5 className=" e-font-14 e-font-weight-400">Title</h5>
            <p className="e-font-14 e-font-weight-500">{data.title}</p>
          </div>
          <div>
            <h5 className=" e-font-14 e-font-weight-400">Content</h5>
            <p className="e-font-14 e-font-weight-500">{data.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
